/**
 * Pronova module route manifest.
 *
 * Each route is mounted under the shell's main-layout when this module is active
 * (selected by APP_CODE=pronova). The shell never knows about Pronova pages beyond
 * this file. The functional domain pages (cdt / hyp / cti / ctk / obd …) are
 * registered dynamically from the DB menu like the other brands; only the public
 * portal landing is declared statically here.
 */
export default {
  code: 'pronova',
  routes: [
    {
      // Profil détaillé de l'utilisateur connecté (clic sur l'avatar du tiroir,
      // cf. NavigationService.goToPersonalProfil) : statique, donc accessible
      // sans droit sur le menu « Utilisateurs » du produit.
      path: '/pronova-my-profile/:userId',
      name: 'pronova-my-profile',
      component: () => import('@app-pages/app/appUserDetail.vue'),
      meta: { appCode: 'pronova', myProfile: true, appCodes: ['pronova'] }
    },
    {
      path: '/pronova-portal',
      name: 'pronova-portal',
      component: () => import('@pronova-pages/portal/pronovaPortal.vue'),
      meta: { appCode: 'pronova', title: 'Pronova' }
    },
  ]
}
